
import { normalizeLink } from "@utils/sharedFunctions"

export default function LinkComponent(props: { socialName: string; url: string | undefined }) {

    return (

        <p> {props.socialName}:&nbsp;
            <a href={`${normalizeLink(props.url) ?? `https://${props.socialName}.com`}`} target="_blank" className="link-text" >
                {props.url}
            </a>
        </p>
    )
}